import axios from "axios";

export const config = {
  appUrl: "/",
  // imageUrl: 'http://localhost/elementeers_crm/assets/front/img',
  imageUrl: 'https://admin.elementeers.com/assets/front/img',
}

export const axiosInstance = axios.create({
  baseURL: "https://admin.elementeers.com/api/",
  // baseURL: "http://localhost/elementeers_crm/api/",


  headers: {
    "Content-Type": "application/json",
    'Access-Control-Allow-Origin': '*'
  },
});


